var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C17.523,2 22,6.477 22,12 C22,17.523 17.523,22 12,22 C10.234,22 8.576,21.574 7.106,20.829 L3.491,21.962 C2.819,22.177 2.13,21.602 2.217,20.9 L2.691,17.003 C2.292,15.459 2,13.798 2,12 C2,6.477 6.477,2 12,2 Z M15.94,11.5 L8.06,11.5 C7.476,11.5 7,11.949 7,12.5 C7,13.051 7.476,13.5 8.06,13.5 L15.94,13.5 C16.524,13.5 17,13.051 17,12.5 C17,11.949 16.524,11.5 15.94,11.5 Z M15.94,8.5 L8.06,8.5 C7.476,8.5 7,8.949 7,9.5 C7,10.051 7.476,10.5 8.06,10.5 L15.94,10.5 C16.524,10.5 17,10.051 17,9.5 C17,8.949 16.524,8.5 15.94,8.5 Z M12.94,14.5 L8.06,14.5 C7.476,14.5 7,14.949 7,15.5 C7,16.051 7.476,16.5 8.06,16.5 L12.94,16.5 C13.524,16.5 14,16.051 14,15.5 C14,14.949 13.524,14.5 12.94,14.5 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.3106588bd0b54bd038ae84823a1203d5.svg";
export { ForwardRef as ReactComponent };